<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="getSelectedIndex"
    ref="gc-base-layout"
    class="touch-sales-order-layout stock-take-prepare"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Stocktake'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode === 'create'
            ? 'Create Stocktake'
            : 'Stocktake #' + baseView.id
        "
        :secondaryLabel="undefined"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar" v-show="!gridExpand">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="baseView.mode != 'create' ? toolBarModel : {}"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
          :customButtons="getHeaderToolbar.customButtons"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form">
        <div class="view-card responsive-paddings">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getHeaderFormItems"
            :isNormal="true"
            :data-model="loaded ? model : {}"
            :formMode="baseView.mode"
            :fromFrom="'gc-header-form'"
            ref="gc-header-form"
            :checkValid="isValid"
            :validationGroup="'gc-header-form'"
            :scrollingEnabled="false"
            :formContentReady="onHeaderFormContentReady"
            :formHeight="baseView.mode != 'create' ? 40 : 'auto'"
          ></gc-form>
        </div>
      </div>

      <div class="gc-details-grid" v-if="baseView.mode != 'create'">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <dx-data-grid
              @toolbar-preparing="toolbarPreparing($event)"
              @content-ready="onContentReady"
              @selection-changed="onStocktakeGridSelectionChanged"
              :height="getGridHeight"
              :data-source="getDataSource"
              :columns="getColumns"
              :ref="'dx-data-grid-comp'"
              :selection="{
                mode: getUserAccess ? 'multiple' : 'none',
                selectAllMode: 'allPages',
                showCheckBoxesMode: 'always',
              }"
              :pager="{ visible: baseView.mode === 'review' }"
            >
              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preloadEnabled="true"
              />
              <template #Record="{ data }">
                <GcRecord
                  :data="data"
                  :primary="data.column['cellTemplateRecord']['primary']"
                  :secondary="data.column['cellTemplateRecord']['secondary']"
                />
              </template>

              <template #menu-cell-template="{ data }">
                <GcMenuCellTemplate
                  class="invoice-print-btn"
                  :data="data"
                  :menuOptions="data.column.ellipsisMenu"
                  :onItemClickCallBack="onItemClickCallBack"
                  :visible="data.column.visible"
                  :disabled="
                    data.column.makeDisabled
                      ? data.column.makeDisabled(data)
                      : false
                  "
                />
              </template>
            </dx-data-grid>
          </template>

          <template #rightContent>
            <gc-filter-panel
              :toolbarVisible="true"
              :toolbar="filterToolbar"
              :formItemData="getFilterFormItems"
              :setGridPanelFilter="setGridPanelFilter"
              :gridFoolter="false"
              :showLoading="showLoading"
              :from="'transaction-screen'"
              :isNormal="false"
              :persistenceKey="undefined"
              :key="'fp-call-schedule'"
              :overWriteClear="true"
              :heightAdjustment="33"
            ></gc-filter-panel>
          </template>
        </gc-filter-split-view>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import {
  StockTakeTabs,
  GetIndexByTabName,
  StockTakeTabsVisibility,
} from "../../../_models/tabdata/inventory/stock-take";
import { StocktakePrepareService } from "../../../_services/api/inventory/stocktake-prepare.service";
import validationEngine from "devextreme/ui/validation_engine";
import { mapGetters } from "vuex";
import { ProductService } from "../../../_services/api/products/product.service";
import { StocktakeCountService } from "../../../_services/api/inventory/stocktake-count.service";
import { FeatureStorage } from "../../../_services/storage";
import { StockTakeListService } from "../../../_services/api/inventory/stock-take-list.service";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  data() {
    return {
      isValid: false,
      headerFormHeight: 0,
      model: {
        CountDate: undefined,
        Branch: [],
        Status: undefined,
      },
      toolBarModel: {
        Status: undefined,
      },
      loaded: false,
      showLeftContainer: true,
      showRightContainer: true,
      gridExpand: false,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.closeFilterPanel();
          },
        },
      },
      filterArray: null,
      stocktakeGridSelectedData: [],
      filterApplied: false,
    };
  },
  beforeMount() {
    this.showLoading(true);
    StockTakeTabsVisibility(this.baseView);
  },
  async created() {
    if (this.baseView.mode === "create") {
      this.model.CountDate = new Date();
    } else {
      await this.onInitialized();
    }

    if (this.isEditable) await this.setActiveAccountingPeriod();
    this.loaded = true;

    this.showLoading(false);

    this.$nextTick(() => {
      var item = document.getElementById("filter-btn");
      if (item) item.classList.add("dx-state-invisible");
    });
  },
  methods: {
    async onInitialized() {
      await StocktakePrepareService.getStockTakeListItemById(this.baseView.id)
        .then((res) => {
          let data = res.data.value[0];
          this.model.CountDate = data.CountDate;
          this.model.Status = data.Status;
          this.toolBarModel.Status = data.FriendlyStatus;
        })
        .catch(() => {
          this.showLoading(false);
        });

      await StocktakePrepareService.getStocktakeBranch(this.baseView.id)
        .then((res) => {
          res.data.value.forEach((element) => {
            this.model.Branch.push(element.BranchCode);
          });
        })
        .catch(() => {
          this.showLoading(false);
        });
    },
    onItemClickCallBack(data, e) {
      if (e.event) {
        this.excludeLine([data.data.ProductCode]);
      }
    },
    closeFilterPanel() {
      this.showRightContainer = !this.showRightContainer;

      var item = document.getElementById("filter-btn");
      item.classList.remove("dx-state-invisible");

      this.$nextTick(() => {
        this.reSizeGrid();
      });
    },
    async setActiveAccountingPeriod() {
      let startDateResult =
        await StocktakePrepareService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.MinCountDate = new Date(accountingPeriod.StartDate);
      }
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    async checkHeaderFormValidation() {
      let headerform = await validationEngine.validateGroup("gc-header-form");

      if (!headerform.isValid)
        this.displayValidationSummary(headerform.brokenRules);
      else {
        if (this.model.Branch.length === 0) {
          this.displayValidationSummary([
            {
              message:
                "Stocktake has no branches selected. Please select one or more branches before attempting to save the transaction again.",
            },
          ]);
          return;
        } else if (this.stocktakeGridSelectedData.length === 0) {
          this.displayValidationSummary([
            {
              message:
                "Stocktake has no items selected. Please select one or more items before attempting to save the transaction again.",
            },
          ]);
          return;
        }

        let payload = {
          CountDate: this.model.CountDate.toSaveDate(),
          StocktakeType: "Item",
          PrepareStocktakeBranches: this.model.Branch.map((item) => {
            return { BranchCode: item };
          }),
          PrepareStocktakeDetails: this.stocktakeGridSelectedData.map(
            (item) => {
              return { Code: item.Code };
            }
          ),
        };

        this.showLoading(true);

        try {
          let res = await StocktakePrepareService.SaveStocktake(payload);
          if (res) {
            this.showLoading(false);
            this.$notify(
              `Stocktake ${res.data.Code} Successfully Saved`,
              "success"
            );
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: "/stocktake",
            });
          }
        } catch (err) {
          this.showLoading(false);
          this.displayServerError(err, "Save Stocktake Failed");
        }
      }
    },

    onHeaderFormContentReady(e) {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      if (e && this.baseView.mode == "create") {
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("CountDate"))
            headerToolBarForm.getEditor("CountDate").instance().focus();
        }, 500);
      }
    },

    // Datagrid releated event
    toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      let itemsToRemoveFromToolBar = ["searchPanel", "columnChooserButton"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        // searchPanel,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxDropDownButton",
          visible: this.baseView.mode !== "create",
          options: {
            tabIndex: -1,
            validationGroup: "formsData",
            icon: "overflow",
            onItemClick: () => {
              this.excludeLines();
            },
            items: [
              {
                text: "Exclude Selected",
              },
            ],
            keyExpr: "text",
            displayExpr: "text",
            showArrowIcon: false,
            dropDownOptions: {
              minWidth: 120,
            },
            visible: this.isEditable && this.getStocktakeManagementAccess,
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            tabIndex: -1,
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              item.classList.add("dx-state-invisible");

              setTimeout(() => {
                this.reSizeGrid();
              }, 100);
            },
          },
        }
      );
    },
    reSizeGrid() {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      dataGrid.beginUpdate();
      dataGrid.updateDimensions();
      dataGrid.endUpdate();
    },
    getAttributeColumns() {
      const records = [];

      for (let i = 1; i <= 20; i++) {
        const record = {
          screenField: `ProductAttribute${i.toString().padStart(2, "0")}`,
          label: `Attribute ${i.toString().padStart(2, "0")}`,
          filterLabel: `Attribute ${i.toString().padStart(2, "0")}`,
          cellTemplateRecord: {
            primary: [
              {
                dataField: `Attribute${i
                  .toString()
                  .padStart(2, "0")}Description`,
              },
            ],
            secondary: [
              {
                dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
              },
            ],
          },
          exportFields: [
            {
              dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
              label: `Attribute ${i.toString().padStart(2, "0")} Code`,
            },
            {
              dataField: `Attribute${i.toString().padStart(2, "0")}Description`,
              label: `Attribute ${i.toString().padStart(2, "0")} Description`,
            },
          ],
          filterIndex: 9,
          filterDataField: `Attribute${i.toString().padStart(2, "0")}`,
          visible: false,
          dataField: `Attribute${i.toString().padStart(2, "0")}Description`,
        };

        records.push(record);
      }

      return records;
    },

    onContentReady(e) {
      this.addGridNoResults(e, {
        addNew: {
          class: "no-data",
          title: "No Product Lines",
          message:
            "Product lines are not available, please filter the list and try again.",
        },
      });

      if (e) this.filterApplied = false;
    },
    onStocktakeGridSelectionChanged(e) {
      if (this.filterApplied) return;

      this.stocktakeGridSelectedData = e.selectedRowsData;

      // e.selectedRowsData.forEach((element) => {
      //   let index = this.stocktakeGridSelectedData.findIndex(
      //     (x) => x.Code === element.Code
      //   );
      //   if (index === -1) {
      //     this.stocktakeGridSelectedData.push(element);
      //   }
      // });

      // e.currentDeselectedRowKeys.forEach((element) => {
      //   let index = this.stocktakeGridSelectedData.findIndex(
      //     (x) => x.Code === element
      //   );
      //   if (index != -1) this.stocktakeGridSelectedData.splice(index, 1);
      // });
    },

    // Filter
    setGridPanelFilter(e, valueChanged) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      // valueChanged === true means filter is applied.
      if (!valueChanged) return;
      else {
        this.filterApplied = true;
        if (this.baseView.mode === "create") {
          dataGrid.clearSelection();
          if (e.length === 0) this.filterArray = false;
          else {
            this.filterArray = undefined;
            let filter = [...e];
            filter.push("and");
            filter.push([["Inactive", "=", "N"]]);
            this.filterArray = [...filter];
          }

          dataGrid.refresh();
        } else {
          if (e.length > 0) {
            let filter = [];
            filter.push([...this.reviewFilter]);
            filter.push("and");
            filter.push([...e]);

            dataGrid.filter(filter);
          } else {
            dataGrid.filter([...this.reviewFilter]);
          }
        }
      }
    },

    excludeLines() {
      if (this.stocktakeGridSelectedData.length === 0) {
        this.displayValidationSummary([
          {
            message: "Select one or more lines and try again.",
          },
        ]);
      } else {
        let lineRecordIds = [];
        this.stocktakeGridSelectedData.forEach((element) => {
          lineRecordIds.push(element.ProductCode);
        });
        this.excludeLine(lineRecordIds);
      }
    },
    async excludeLine(ProductCodes) {
      let confirmExclude = await this.$confirm(
        "Are you sure you would like to exclude the selected Item(s) from the Stocktake?",
        "Exclude Stocktake"
      );

      if (confirmExclude) {
        let payload = {
          StocktakeCode: this.baseView.id,
          StocktakeProductCodes: ProductCodes,
        };
        this.showLoading(true);
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        await StocktakePrepareService.setLineExclude(payload)
          .then((res) => {
            if (res) this.showLoading(false);
            dataGrid.clearSelection();
            this.$nextTick(() => {
              dataGrid.refresh();
            });
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Exclude Stocktake line Failed");
          });
      }
    },
    async cancelStockTake() {
      let confirmCancel = await this.$confirm(
        "Are you sure you would like to cancel this Stocktake?",
        "Cancel Stocktake"
      );

      if (confirmCancel) {
        let payload = { Code: this.baseView.id };
        this.showLoading(true);
        await StockTakeListService.cancelStockTake(payload)
          .then(() => {
            this.showLoading(false);
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: "/stocktake",
            });
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Cancel Stocktake line Failed");
          });
      }
    },

    // Genereta
    async onGenerateClick() {
      if (this.model.Branch.length === 0) {
        this.displayValidationSummary([
          {
            message:
              "Stocktake has no branches selected. Please select one or more branches before attempting to generate the transaction again.",
          },
        ]);
        return;
      } else {
        let filters = [["Inactive", "=", "N"]];
        for (const key in this.model) {
          let filter = [];
          if (key != "CountDate" && key != "Branch" && key != "Status") {
            if (Array.isArray(this.model[key])) {
              this.model[key].forEach((element) => {
                if (filter.length > 0) filter.push("or");
                if (key === "SupplierList")
                  filter.push([key, "contains", element]);
                else filter.push([key, "=", element]);
              });
            }
          }

          if (filter.length > 0) {
            if (filters.length > 0) filters.push("and");
            filters.push(filter);
          }
        }

        const response = await ProductService.dataSourceConfig(
          "api/ProductList",
          {
            filter: filters,
            key: "Code",
            preventPagination: true,
            select: ["Code", "Description1", "Inactive", "Status"],
          }
        );

        this.showLoading(true);
        response
          .load()
          .then((res) => {
            this.generatedItems = res;
            this.saveGeneratedItemData(res);
          })
          .catch(() => {
            this.showLoading(false);
          });
      }
    },
    async saveGeneratedItemData(items) {
      let payload = {
        CountDate: this.model.CountDate.toSaveDate(),
        StocktakeType: "Item",
        PrepareStocktakeBranches: this.model.Branch.map((item) => {
          return { BranchCode: item };
        }),
        PrepareStocktakeDetails: items.map((item) => {
          return { Code: item.Code };
        }),
      };

      try {
        let res = await StocktakePrepareService.SaveStocktake(payload);
        if (res) {
          this.showLoading(false);
          this.$notify(
            `Stocktake ${res.data.Code} Successfully Saved`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: "/stock-take-prepare/review/" + res.data.Code,
            })
            .then(async () => {
              this.showLoading(true);
              await this.onInitialized();

              this.showLoading(false);
            });
        }
      } catch (err) {
        this.showLoading(false);
        this.displayServerError(err, "Save Stocktake Failed");
      }
    },
    async commitStockTake() {
      let confirmCommit = await this.$confirm(
        `Are you sure you would like to commit this Stocktake?`,
        "Commit Stocktake"
      );
      if (confirmCommit) {
        this.showLoading(true);
        let payload = { Code: this.baseView.id };

        await StockTakeListService.commitStockTake(payload)
          .then(() => {
            this.showLoading(false);

            this.$notify(
              `Stocktake ${this.baseView.id} Successfully Commited`,
              "success"
            );
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: "/stocktake",
            });
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Stocktake Commit Failed");
          });
      }
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getGridHeight() {
      return this.gridHeight - 20 - 55 - this.headerFormHeight;
      // 20 => Top & Bottom Padding
      // 55 => Toolbar Height + Toolbar bottom padding
    },
    backButtonRoute() {
      return "/stocktake";
    },
    getTabs() {
      return StockTakeTabs({
        ...this.baseView,
        ...{ isEditable: this.getUserAccess },
      });
    },
    getSelectedIndex() {
      return GetIndexByTabName("Prepare", this.baseView);
    },
    getHeaderToolbar() {
      return {
        audit: false,
        status: this.baseView.mode != "create",
        notes: false,
        save: false,
        customButtons:
          this.baseView.mode !== "create"
            ? [
                {
                  text: "Cancel",
                  type: "normal",
                  onClick: this.cancelStockTake,
                  visible: this.isEditable,
                  disabled: !this.getStocktakeManagementAccess,
                },
                {
                  text: "Commit",
                  type: "normal",
                  class: "save-btn-icon",
                  onClick: this.commitStockTake,
                  visible: this.isEditable,
                  disabled: !this.getStocktakeManagementAccess,
                },
              ]
            : undefined,
        // ellipsis:
        //   this.baseView.mode != "create"
        //     ? {
        //         menuItems: [
        //           {
        //             menuText: "Cancel",
        //             disabled: !this.getUserAccess,
        //           },
        //         ],
        //         visible: this.isEditable,
        //         clickAction: () => {
        //           this.cancelStockTake();
        //         },
        //       }
        //     : undefined,
      };
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass:
            this.baseView.mode === "create"
              ? "header-form-items header-form-items-create"
              : "header-form-items",
          colCount: 2,
          items: [
            {
              screenField: "DateIn",
              dataField: "CountDate",
              label: {
                text: "Count Date",
              },
              editorOptions: {
                min: this.MinCountDate,
                max: this.getTomorrowDate,
                tabIndex: 1,
              },
              required: true,
            },
            {
              screenField: "Branch",
              dataField: "Branch",
              editorType: "dxTagBox",
              label: {
                text: "Branch",
              },
              editorOptions: {
                showSelectionControls: true,
                displayedAllTags: this.baseView.mode === "review",
                tabIndex: 6,
              },
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          visible: this.baseView.mode === "create",
          items: [
            {
              screenField: "Product",
              dataField: "Code",
              editorType: "dxTagBox",
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 2,
              },
            },
            {
              screenField: "ProductCategory2",
              editorType: "dxTagBox",
              label: {
                text: "Category 2",
              },
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 7,
              },
            },
            {
              screenField: "Supplier",
              dataField: "SupplierList",
              editorType: "dxTagBox",
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 3,
              },
            },
            {
              screenField: "ProductCategory3",
              editorType: "dxTagBox",
              label: {
                text: "Category 3",
              },
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 8,
              },
            },
            {
              screenField: "ProductType",
              editorType: "dxTagBox",
              label: {
                text: "Type",
              },
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 4,
              },
            },
            {
              screenField: "ProductCategory4",
              editorType: "dxTagBox",
              label: {
                text: "Category 4",
              },
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 9,
              },
            },
            {
              screenField: "ProductCategory1",
              editorType: "dxTagBox",
              label: {
                text: "Category 1",
              },
              editorOptions: {
                showSelectionControls: true,
                tabIndex: 5,
              },
            },
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items-btn",
              colCount: 2,
              items: [
                {
                  dataField: "Clear",
                  label: {
                    text: " ",
                    visible: false,
                  },
                  editorType: "dxButton",
                  cssClass: "btn-clear",
                  editorOptions: {
                    validationGroup: "gc-header-form",
                    onClick: async () => {
                      // this.onGenerateClick();
                    },
                    text: "Clear",
                    type: "normal",
                    rtlEnabled: false,
                    width: 105,
                  },
                },
                {
                  dataField: "Generate",
                  label: {
                    text: " ",
                    visible: false,
                  },
                  editorType: "dxButton",
                  cssClass: "btn-generate",
                  editorOptions: {
                    validationGroup: "gc-header-form",
                    onClick: async () => {
                      this.onGenerateClick();
                    },
                    text: "Generate",
                    type: "default",
                    rtlEnabled: false,
                    width: 105,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getTomorrowDate() {
      let tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 1);
      return tomorrow;
    },
    getColumns() {
      return this.parseGridColumns(this.columns);
    },
    getDataSource() {
      if (this.baseView.mode === "create") {
        if (this.filterArray)
          return ProductService.dataSourceConfig("api/ProductList", {
            // select: this.getSelectFields(this.getColumns),
            filter: this.filterArray ? this.filterArray : null, // [["Inactive", "=", "N"]],
            key: "Code",
          });
        else return [];
      } else {
        return StocktakeCountService.dataSourceConfig(
          "api/StocktakeCountProductList",
          {
            key: "ProductCode",
            filter: this.reviewFilter,
          }
        );
      }
    },
    getFilterFormItems() {
      return this.columns
        .map((c) => {
          if (c.filterIndex != undefined) {
            return c;
          }
        })
        .filter((x) => x != null)
        .sort(function (a, b) {
          return a.filterIndex - b.filterIndex;
        });
    },
    columns() {
      return [
        {
          screenField: "Item",
          label: "Product",
          gridDataField:
            this.baseView.mode === "create"
              ? "Description1"
              : "ProductDescription1",

          filterDataField:
            this.baseView.mode === "create"
              ? "Description1"
              : "ProductDescription1",
          sortOrder: "asc",
          sortIndex: 0,
          allowHiding: false,
          cellTemplateRecord:
            this.baseView.mode === "create"
              ? {
                  primary: [
                    {
                      dataField: "Description1",
                    },
                  ],
                  secondary: [
                    {
                      dataField: "Code",
                    },
                  ],
                }
              : {
                  primary: [
                    {
                      dataField: "ProductDescription1",
                    },
                  ],
                  secondary: [
                    {
                      dataField: "ProductCode",
                    },
                  ],
                },
          exportFields: [
            {
              dataField:
                this.baseView.mode === "create" ? "Code" : "ProductCode",
              label: "Product Code",
            },
            {
              dataField:
                this.baseView.mode === "create"
                  ? "Description1"
                  : "ProductDescription1",
              label: "Product Description 1",
            },
            {
              dataField:
                this.baseView.mode === "create"
                  ? "Description2"
                  : "ProductDescription2",
              label: "Product Description 2",
            },
            {
              dataField:
                this.baseView.mode === "create"
                  ? "Description3"
                  : "ProductDescription3",
              label: "Product Description 3",
            },
          ],
          fixed: true,
          fixedPosition: "left",
        },
        {
          screenField: "Code",
          filterLabel: "Product Code",
          dataField: "Code",
          showInColumnChooser: false,
          visible: false,
          allowSearch: false,
          type: "Text",
        },
        {
          screenField: "Name",
          filterLabel: "Product",
          filterDataField: "ProductSearchText",
          showInColumnChooser: false,
          visible: false,
          type: "Text",
          filterIndex: 1,
        },
        {
          screenField: "ProductCategory1",
          label: "Category 1",
          filterLabel: "Category 1",
          filterIndex: 3,
        },
        {
          screenField: "ProductCategory2",
          label: "Category 2",
          filterLabel: "Category 2",
          filterIndex: 4,
        },
        {
          screenField: "ProductCategory3",
          label: "Category 3",
          filterLabel: "Category 3",
          filterIndex: 5,
        },
        {
          screenField: "ProductCategory4",
          label: "Category 4",
          filterLabel: "Category 4",
          filterIndex: 6,
        },
        {
          screenField: "ProductType",
          label: "Type",
          filterLabel: "Type",
          filterIndex: 7,
        },
        {
          screenField: "ProductSize",
          label: "Size",
          filterLabel: "Size",
          filterIndex: 8,
        },
      ]
        .concat(this.getAttributeColumns())
        .concat({
          screenField: "Supplier",
          gridDataField: "SupplierList",
          visible: false,
          showInColumnChooser: false,
          filterIndex: 2,
          filterDataField: "SupplierList",
          filterOperator: "contains",
          allowSearch: false,
        })
        .concat({
          screenField: "GridRecordEllipsisMenu",
          cssClass: "padding-7",
          width: 50,
          allowSearch: false,
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Exclude Selected",
                  data: data,
                  clickAction: this.excludeLine,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          // makeDisabled: (data) => {
          //   if (!data) return true;
          // },
          dropDownOptions: {
            width: 120,
          },
          visible: this.getStocktakeManagementAccess,
        });
    },
    reviewFilter() {
      return [
        ["StocktakeCode", "=", parseInt(this.baseView.id)],
        "and",
        ["Status", "<>", "X"],
      ];
    },
    getStocktakeManagementAccess() {
      return FeatureStorage.checkPermission("StocktakeManagement", "create");
    },
    getUserAccess() {
      return (
        this.isEditable &&
        (FeatureStorage.checkPermission("StocktakeManagement", "create") ||
          FeatureStorage.checkPermission("StocktakeCount", "create"))
      );
    },
    isEditable() {
      return this.model.Status != "C" && this.model.Status != "X";
    },
  },
};
</script>

<style lang="scss">
.stock-take-prepare {
  .dx-button[aria-label="save"] {
    background-color: #03a9f4 !important;
    color: #fff !important;

    .dx-button-content {
      display: flex;
      align-items: center;
    }

    .dx-icon::before {
      color: white !important;
    }
  }

  .gc-header-form {
    .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
        .dx-editor-outlined
      )::after {
      border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
    }

    div.dx-tagbox {
      .dx-texteditor-container {
        padding-bottom: 2px;
      }
    }

    .dx-tagbox:not(.dx-texteditor-empty)
      .dx-texteditor-input-container.dx-tag-container {
      margin-top: unset !important;
      padding-bottom: unset !important;
      padding-top: 1px !important;
      .dx-tag {
        margin-bottom: unset !important;
        margin-top: unset !important;

        .dx-tagbox .dx-texteditor-input {
          height: 24px !important;
        }
      }

      input {
        padding-top: 3px !important;
      }
    }

    .header-form-items-create {
      padding-bottom: unset !important;
    }

    .header-form-items-btn {
      padding-top: 15px !important;

      .dx-item.dx-box-item {
        text-align: end;
        .dx-item-content.dx-box-item-content.dx-box.dx-widget.dx-collection {
          > div:last-child {
            flex: unset !important;
          }
        }
      }
      .btn-clear {
        padding-right: unset;
      }

      .btn-clear,
      .btn-generate {
        padding-top: 10px;
      }
    }
  }
}
</style>
